import * as React from 'react';

import { CircularProgress } from '@material-ui/core';

export interface IProps extends React.PropsWithChildren {
  size?: number;
  active?: boolean;
  style?: any;
  className?: string;
}

class LoadingSpinner extends React.Component<IProps> {
  static defaultProps = {
    size: 60,
    style: {},
    active: true
  };

  render() {
    const { size, active, style, className } = this.props;

    if (!active) {
      return <React.Fragment>{this.props.children}</React.Fragment>;
    }

    return (
      <div className={`loading-overlay ${className}`} style={style}>
        <CircularProgress
          size={size}
          mode="indeterminate"
          className="progress-circle-indeterminate"
        />
      </div>
    );
  }
}

export default LoadingSpinner;
